<div class="filter-value" data-testid="filter-value">
  @if (props.label) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="filter-value__label">{{ props.label }}</label>
  }
  @switch (mode) {
    @case ('multi') {
      <div class="filter-value__checklist">
        @for (option of fieldOptions; track option.value) {
          <label class="filter-value__check" [attr.data-testid]="'filter-value-check-' + option.value">
            <input
              type="checkbox"
              [checked]="isChecked(option.value)"
              (change)="toggle(option.value)"
              [attr.data-testid]="'filter-value-check-input-' + option.value"
            />
            <span>{{ option.label }}</span>
          </label>
        }
        @if (!fieldOptions.length) {
          <span class="filter-value__empty">{{ 'reports.builder.filters.noOptions' | translate }}</span>
        }
      </div>
    }
    @case ('single-select') {
      <app-dropdown-field [field]="selectFieldConfig" data-testid="filter-value-select" />
    }
    @case ('boolean') {
      <app-dropdown-field [field]="booleanFieldConfig" data-testid="filter-value-boolean" />
    }
    @case ('number') {
      <input
        class="filter-value__input"
        type="number"
        [value]="scalarValue"
        (input)="setScalar($any($event.target).value)"
        data-testid="filter-value-number"
      />
    }
    @case ('date') {
      <input
        class="filter-value__input"
        type="datetime-local"
        [value]="scalarValue"
        (input)="setScalar($any($event.target).value)"
        data-testid="filter-value-date"
      />
    }
    @default {
      <input
        class="filter-value__input"
        type="text"
        [value]="scalarValue"
        (input)="setScalar($any($event.target).value)"
        [attr.placeholder]="props.description || ''"
        data-testid="filter-value-text"
      />
    }
  }
</div>
